var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3822 15.8888C28.3822 22.7888 22.7697 28.3888 15.8822 28.3888L15.5325 28.384C8.79398 28.1986 3.3822 22.6718 3.3822 15.8888C3.3822 9.00129 8.9822 3.38879 15.8822 3.38879C22.7697 3.38879 28.3822 9.00129 28.3822 15.8888ZM19.3697 15.8888C19.3697 15.6388 19.2697 15.4013 19.0947 15.2263L14.7322 10.8888C14.5572 10.7013 14.3197 10.6138 14.0822 10.6138C13.8322 10.6138 13.5947 10.7013 13.4072 10.8888C13.0447 11.2638 13.0447 11.8513 13.4197 12.2138L17.1072 15.8888L13.4197 19.5638C13.0447 19.9263 13.0447 20.5263 13.4072 20.8888C13.7822 21.2638 14.3697 21.2638 14.7322 20.8888L19.0947 16.5513C19.2697 16.3763 19.3697 16.1388 19.3697 15.8888Z",
    fill: "#0054E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.781bcf37b7fd2fa710ec08409d1b4ab3.svg";
export { ForwardRef as ReactComponent };